<template>
  <div class="benefits" v-html="storeInformation.eShopBenefits"></div>
</template>

<script setup lang="ts">
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultStore = useResultsStore();

const storeInformation = computed(() => resultStore.storeInformation);
</script>

<style lang="scss" scoped>
.benefits {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 40px;
  margin-bottom: 64px;
  @include point-md {
    grid-template-columns: repeat(2, 1fr);
  }
  @include point-lg {
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 80px;
  }
}
:deep(.benefit) {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px;

  position: relative;
}
:deep(.benefit:hover) {
  .benefit__icon {
    transform: scale(1.1);
  }
  .benefit__name {
    color: var(--color-link-hover-dark);
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid var(--background-beige);
    animation: clippath 3s linear reverse;
    pointer-events: none;
  }
  @keyframes clippath {
    0%,
    100% {
      clip-path: inset(0 0 95% 0);
    }
    25% {
      clip-path: inset(0 95% 0 0);
    }
    50% {
      clip-path: inset(95% 0 0 0);
    }
    75% {
      clip-path: inset(0 0 0 95%);
    }
  }
}
:deep(.benefit__icon) {
  display: block;
  width: 20px;
  height: 20px;
  margin-bottom: 16px;
  transition: 0.2s linear transform;
}
:deep(.benefit__name) {
  font-weight: bold;
  font-size: rem(16);
  text-align: center;
  margin-bottom: 12px;
  transition: 0.2s linear color;
  &:hover {
    color: var(--color-link-hover-dark);
  }
}
:deep(.benefit__description) {
  font-weight: 500;
  font-size: rem(12);
  color: var(--color-dark-grey);
}
</style>
